import { useEffect, useRef, useState } from 'react';
import { Badge, IconButton, Menu, Tooltip } from '@material-ui/core';
import { Notifications } from '@material-ui/icons';
import NotificationList from './customer.comment.notification.list.component';
import notificationService from '../../domain/services/notification/customer.comment.notification.service';

function CustomerCommentNotifications() {
    const [notifications, setNotifications] = useState([]);
    const [anchor, setAnchor] = useState(null);
    const [error, setError] = useState(false);
    const revision = useRef(0);
    const mounted = useRef(false);

    useEffect(() => {
        let active = true;
        mounted.current = true;
        const refresh = async () => {
            const current = ++revision.current;
            try {
                const result = await notificationService.find();
                if (active && current === revision.current) {
                    setNotifications(result);
                    setError(false);
                }
            } catch (failure) {
                if (active && current === revision.current) setError(true);
            }
        };
        refresh();
        const unsubscribe = notificationService.subscribe(refresh);
        return () => {
            active = false;
            mounted.current = false;
            unsubscribe();
        };
    }, []);

    const markRead = async id => {
        await notificationService.read(id);
        revision.current += 1;
        if (!mounted.current) return;
        setNotifications(current => current.filter(notification => `${notification.id}` !== `${id}`));
    };

    return <>
        <Tooltip title={error ? 'Não foi possível carregar as notificações' : 'Notificações'}>
            <IconButton
                size="small"
                color="inherit"
                aria-label="Notificações dos comentários"
                aria-haspopup="true"
                onClick={event => setAnchor(event.currentTarget)}
            >
                <Badge badgeContent={notifications.length} color="error" overlap="circular">
                    <Notifications style={{ width: 28, height: 28 }} />
                </Badge>
            </IconButton>
        </Tooltip>
        <Menu anchorEl={anchor} open={!!anchor && !!notifications.length} onClose={() => setAnchor(null)}>
            <div><NotificationList notifications={notifications} onRead={markRead} /></div>
        </Menu>
    </>;
}

export default CustomerCommentNotifications;
